<template slot="header" slot-scope="scope">
<div>
    <el-table :data="tableData" style="width: 100%" max-height="1000">
    <el-table-column  prop="ename" label="企业名称" min-width="150">
    </el-table-column>
      <el-table-column  prop="ecode" label="统一社会信用代码" min-width="150">
    </el-table-column>
    <el-table-column prop="contacts" label="联系人" min-width="120">
    </el-table-column>
    <el-table-column prop="tel" label="联系电话" min-width="120">
    </el-table-column>
      <el-table-column prop="state" label="状态" min-width="120" :formatter="stateFormat">
    </el-table-column>
      <el-table-column  label="操作">
      <template slot-scope="scope" >
<router-link :to="{path:'/enterquery',query:{pid:scope.row.id}}"  class="sidebar-nav-link" >
        <el-button type="text" size="small">查看详情</el-button>
          </router-link>
      </template>
    </el-table-column>
  </el-table>
</div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {
  name: 'enterquerylist',
  data () {
    return {
      showHeader: false,
      form1: {
        eName: '',
        eCode: '',
        jperson: '',
        tel: '',
        createTime: '',
        updateTime: '',
        contacts: '',
        indSubname: '',
        provName: '',
        cityName: '',
        state: '',
        eAddr: '',
        enterprise: '',
        website: '',
        email: '',
        introduce: '',
        foundtime: '',
        staff: '',
        industry: '',
        advantage: '',
        classify: ''
      },
      tableData: [],
      pid: ''
    }
  },
  created () {
    var that = this
    /* 获取父页面参数 */

    /* 后台申请默认值 */
    dataGetUrl(rootPathssb.rootPath + '/user/app/finds').then(function (response) {
      console.log(response)
      if (response.data.result === 1) {
        console.log(response)
        that.tableData = response.data.info
      };

      console.log(response.data.info)
    }).catch(function (error) {
      console.log(error); console.log('aaa')
    })
  },
  methods: {
    getPageDate (event) {
      let that = this
      dataGetUrl(rootPathssb.rootPath + '/user/app/finds').then(function (response) {
        if (response.data.result === 1) {
          that.tableData = response.data.info
          console.log('cg')
        };console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222)
      })
    }, // 获取数据
    stateFormat (row, column) {
      if (row.state === '1') {
        return '受理中'
      } if (row.state === '0') {
        return '待受理'
      } else {
        return '完成'
      }
    } // 状态返回
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterquerylist.vue